export const CANCEL_SMARTPHONE_MODAL_FORM = 'CANCEL_SMARTPHONE_MODAL_FORM'
